export const GetCurrentUser = (api) => {
    return api.get("/api/v1/Account/User")
}

export const Login = (api, data) => {
    return api.post("/api/v1/Account/Login", data)
}